"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileImage = void 0;
var react_1 = __importDefault(require("react"));
var constants_1 = require("../constants");
var ProfileImage = function (_a) {
    var height = _a.height, size = _a.size, width = _a.width;
    return (react_1.default.createElement("svg", { width: width || size || constants_1.DEFAULT_ICON_SIZE, height: height || size || constants_1.DEFAULT_ICON_SIZE, viewBox: '0 0 132 132', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react_1.default.createElement("circle", { cx: '66', cy: '66', r: '66', fill: '#EDE2FF' }),
        react_1.default.createElement("path", { opacity: '0.8', d: 'M87 79.7907C87 86.8548 77.598 89 66 89C54.402 89 45 86.8548 45 79.7907C45 72.7266 54.402 67 66 67C77.598 67 87 72.7266 87 79.7907Z', fill: 'white' }),
        react_1.default.createElement("path", { opacity: '0.8', d: 'M66 62C71.525 62 76 57.525 76 52C76 46.475 71.525 42 66 42C60.475 42 56 46.475 56 52C56 57.525 60.475 62 66 62Z', fill: 'white' })));
};
exports.ProfileImage = ProfileImage;
